// Footer disclaimer for the Summary view — a single fixed caveat
// about how adherence/TDEE are computed. No props, no variants.

import React, { memo } from "react";
import { useTranslation } from "react-i18next";

export const SummaryDisclaimer = memo(() => {
  const { t } = useTranslation("athlete-portal");
  return (
    <p className="np-summary-disclaimer">
      {t("nutritionPage.progress.summaryDisclaimer")}
    </p>
  );
});
